/* eslint-disable prefer-destructuring */
import React from 'react';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_SIZE,
} from '@gcloud-npm/next12.components.text-info';
import { scrollIntoView } from 'seamless-scroll-polyfill';
import Button from '@gcloud-npm/next12.components.button-n';

export const GetBandaPromoOrInfo = (bandaInfo, bandaPromo) => {
  // Obtención de la banda Info o la Banda promo,
  // en caso de que hayan ambas, se tomará bandaInfo
  if (bandaInfo) {
    return (
      <TextInfo
        text={bandaInfo}
        kind={TEXT_INFO_KIND.SPAN}
        color={TEXT_INFO_COLOR.PURPLE}
        size={TEXT_INFO_SIZE.CAPTION2}
        className="bandaInfo"
      />
    );
  }
  if (bandaPromo) {
    return (
      <TextInfo
        text={bandaPromo}
        kind={TEXT_INFO_KIND.SPAN}
        color={TEXT_INFO_COLOR.WHITE}
        size={TEXT_INFO_SIZE.CAPTION2}
        className="bandaPromo"
      />
    );
  }
  return null;
};

// eslint-disable-next-line react/no-unstable-nested-components
export const GetButton = (cta, customClickEvent, btnTaggingInfo) => {
  // Obtención del boton con evento o con enlace
  const showButtonWithLink = cta && cta.urlButton;
  const showButtonWithEvent = customClickEvent;
  let button = <div />;

  if (showButtonWithLink) {
    button = (
      <Button
        label={cta.btnText}
        taggingInfo={btnTaggingInfo}
        href={cta.urlButton}
        forceExternal
      />
    );
  } else if (showButtonWithEvent) {
    button = (
      <Button
        label={cta.btnText}
        taggingInfo={btnTaggingInfo}
        onClick={customClickEvent}
        forceExternal
      />
    );
  }
  return button;
};

export const GetCtaButtonClassName = (cta) => {
  const withBorder =
    cta.textPrecontrato || cta.description || cta.textLegals
      ? 'withBorder'
      : '';
  const ctaButtonClassName = `ctaButton ${withBorder}`;
  return ctaButtonClassName;
};

// Función para hacer scroll hacia el elemento del id seleccionado
const ScrollToId = (moduloId) => {
  if (moduloId) {
    const modulo = document.getElementById(moduloId);
    if (modulo) {
      scrollIntoView(modulo, { behavior: 'smooth', block: 'start' });
    }
  }
};

export const GetCustomClickEvent = (ctaEvent) => {
  if (!ctaEvent) {
    return null;
  }
  // Lo que se recibe es similar a scroll=moduloCards
  //                                 ↑         ↑
  //                     Nombre de función   Id de módulo

  let param = null;
  let eventName = '';
  const index = ctaEvent.indexOf('=');
  if (index > 0) {
    eventName = ctaEvent.split('=')[0];
    param = ctaEvent.split('=')[1];
  }

  // Objeto con las funciones disponibles.
  // Lo que recibe desde API es el nombre en minuscula de la propiedad que tiene asociada la funcion especificada en código
  const functions = {
    scroll: () => ScrollToId(param),
  };

  // Devuelve la funcion  que corresponda segun el nombre recibido en la api, sin importar mayusculas
  return functions[eventName.toLowerCase()];
};
